import { createApiMutationHook, IApiMutationFunction } from "../../utils/api";
import { mapRelationalValue, RelationalValue } from "../../utils/filters";
import { IBriefResource } from "../types/IBriefResource";

export interface IBriefDeleteMutationParameters {
    brief: RelationalValue<IBriefResource>;
}

export type IBriefDeleteMutationResult = IBriefResource;

export const briefDeleteMutation: IApiMutationFunction<IBriefDeleteMutationParameters> = ({ brief }) => {
    return {
        method: "DELETE",
        url: `/briefs/${mapRelationalValue(brief)}`,
    };
};

export const useBriefDeleteMutation = createApiMutationHook<IBriefDeleteMutationParameters, IBriefDeleteMutationResult>(
    briefDeleteMutation,
);
